import { render, staticRenderFns } from "./newLogin.vue?vue&type=template&id=48404fea&scoped=true&"
import script from "./newLogin.vue?vue&type=script&lang=js&"
export * from "./newLogin.vue?vue&type=script&lang=js&"
import style0 from "./newLogin.vue?vue&type=style&index=0&id=48404fea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48404fea",
  null
  
)

export default component.exports